<script>

import { orders } from '../stores/oders-store'

</script>

<main>
    {#if $orders}
        <div class="table-responsive">
            <table class="table-dark table align middle">
                <thead>
                    <tr>
                        <th class="date" scope="col">Time</th>
                        <th scope="col">LTT</th>
                        <th scope="col">LTT/ETH</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each $orders.filledOrders as order}
                        <tr class="align middle">
                            <td class="text-muted date">{order.formattedTimestamp}</td>
                            <td>{order.tokenAmount}</td>
                            <td
                            class={`text-${order.tokenPriceClass}`}
                            >{order.tokenPrice}</td>
                        </tr>
                    {/each}
                    </tbody>
            </table>
        </div>
    {/if}
</main>